<template>
    <div class="promotionHeader-component">
        <!-- 有选择城市定位的头部 -->
        <div class="selectCityHeader" v-if="type === 1">
            <van-sticky :class="{notTop: isWeixin || isApp}" style="height: 1.17333rem">
                <div class="location" @click="getMyLocation"> <i class="ico ico-icon_41"></i><span>{{address | toSubStr}}</span><i class="ico ico-icon_94"></i></div>
                <div class="search">
                    <van-search v-model="value" shape="round" placeholder="输入商品关键词">
                        <template #left-icon>
                            <i class="ico ico-icon_96"></i>
                        </template>
                    </van-search>
                    <div class="clickBox" @click="jumpPage" v-if="searchType === 'jump'"></div>
                </div>
            </van-sticky>
        </div>
        <!-- 有门店具体信息的头部或者单纯是一个搜索框的头部 -->
        <div class="hasdataHeader" v-else>
            <div class="storeInfo" v-if="hideStoreInfo">
                <div class="storeName">
                    <div class="title van-ellipsis">{{data.sstore_name}}</div>
                    <div class="icon"><a :href="`tel:${data.sstore_phone}`"><i class="ico ico-icon_71"></i></a></div>
                </div>
                <div class="storeWrap">
                    <div class="text">
                        <span class="distance">距离您<i class="red">{{data.distance | getKM}}</i>{{data.distance > 1000 ? '公里' : '米'}}</span>
                        <span class="address van-ellipsis">{{data.sstore_address}}</span>
                    </div>
                    <div class="icon" @click="goMap"><i class="ico ico-icon_70"></i></div>
                </div>
            </div>
            <div class="search">
                <van-search v-model="value" shape="round" placeholder="输入商品名称" @blur="onBlur">
                    <template #left-icon>
                        <i class="ico ico-icon_96"></i>
                    </template>
                </van-search>
                <div class="clickBox" @click="jumpPage" v-if="searchType === 'jump'"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapState
} from 'vuex'
import { isEmpty } from 'lodash'
import { Sticky } from 'vant'

export default {
    name: 'promotionHeader',
    props: {
        type: {
            type: Number,
            default: 1, // 1: 有选择城市定位的头部, 反之就显示其他
        },
        searchType: {
            type: String,
            default: 'jump', // jump:点击搜索框跳转页面, goods: 搜索商品
        },
        /**
         * 地理位置-经纬度
        */
        position: {
            type: Object,
            default: () => {
                return {
                    latitude: '',
                    longitude: ''
                }
            }
        },
        /**
         * @param store_name 门店名称
         * @param distance 距离
         * @param store_address 门店地址
         * @param store_phone 门店dianh
        */
        data: {
            type: Object,
            default: null,
            required: true
        },
        /**
         * 是否自动聚焦
        */
        autofocus: {
            type: Boolean,
            default: false
        },
        address: {
            type: String,
            default: ''
        }
    },
    components: {
        [Sticky.name]: Sticky
    },
    filters: {
        toSubStr (value) {
            return value ? value.toString().substr(0, 8) : '请选择城市'
        },
        getKM (value) {
            let val = Number(value)
            let result = ''
            if (val < 1000) {
                result = `${parseInt(val)}`
            } else {
                result = `${(val / 1000).toFixed(1)}`
            }
            return result
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin,
            icarAppInfo: ({ appInfo }) => appInfo.icarAppInfo
        }),
        isApp () {
            return this.icarAppInfo.app_name === 'iCar_app'
        },
        hideStoreInfo () {
            return !!this.position.latitude && !!this.position.longitude
        }
    },
    data () {
        return {
            value: '',
            latitude: '',
            longitude: ''
        }
    },
    watch: {
        position: {
            handler: function (obj) {
                if (!isEmpty(obj)) {
                    Object.assign(this, obj)
                }
            },
            deep: true,
            immediate: true
        }
    },
    created () {

    },
    activated () {

    },
    mounted () {
        // this.onFocus()
    },
    methods: {
        ...mapActions([
            'getLocation',
        ]),
        jumpPage () {
            this.$emit('callback', {type: 'jump', cb: this.goPage})
        },
        // onFocus () {
        //     if (this.autofocus && this.searchType === 'goods') {
        //         document.querySelector('.hasdataHeader input').focus()
        //     }
        // },
        goPage (query) {
            this.$router.push({
                path: this.type === 1 ? 'customGoodsList' : 'customSingularGoodsList',
                query
            })
        },
        selectAddress (query) {
            this.$router.push({
                path: '/selectAddress',
            })
        },
        // 点击导航去门店
        goMap () {
            window.location.href = `https://api.map.baidu.com/marker?location=${this.position.latitude},${this.position.longitude}&title=${this.data.sstore_name}&content=${this.data.sstore_address}&output=html&src=webapp.baidu.openAPIdemo`
        },
        // onSearch () {
        //     this.$emit('callback', {type: 'search', value: this.value})
        // },
        onBlur () {
            this.$emit('callback', {type: 'search', value: this.value})
        },
        getMyLocation () {
            this.$emit('callback', {type: 'selectAddress', cb: this.selectAddress})
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import "../../../assets/stylus/variables";
    .promotionHeader-component
        width 100%
        .selectCityHeader
            height 88px
            background $fcWhite
            display flex
            align-items center
            width 100%
            > div
                width 100%
            .location
                flex auto
                display flex
                align-items center
                padding-left 28px
                width 375px
                span
                    font-size $fontBase
                    padding 0 16px 0 5px
                    white-space nowrap
            .search
                position relative
                flex auto
                height 88px
                .clickBox
                    position absolute
                    top 0
                    left 0
                    z-index 9
                    width 100%
                    height 100%
        .hasdataHeader
            .storeInfo
                padding 0 30px 0
                box-sizing border-box
                height 114px
                background $fcWhite
                display flex
                flex-direction column
                justify-content center
                .storeName
                    display flex
                    align-items center
                    justify-content space-between
                    color $black333
                    font-size $fontListTitle
                    .title
                        width calc(100% - 80px)
                        line-height 1.2
                    .icon
                        position relative
                        top 10px
                        width 80px
                        text-align right
                        a
                            display block
                .storeWrap
                    display flex
                    align-items center
                    justify-content space-between
                    font-size $fontSmall
                    color $fcGrey
                    .text
                        display flex
                        align-items center
                        width calc(100% - 80px)
                        .distance
                            white-space nowrap
                            padding-right 20px
                    .icon
                        width 80px
                        text-align right
                        position relative
                        top 10px
                    .red
                        color $fcRed
                        font-style normal
            .search
                position relative
                height 88px
                .clickBox
                    position absolute
                    top 0
                    left 0
                    z-index 9
                    width 100%
                    height 100%
</style>
<style lang="stylus">
    @import "../../assets/stylus/variables";
    .promotionHeader-component
        .van-sticky
            display flex
            background $fcWhite
            &.van-sticky--fixed
                top 88px
        .notTop
            .van-sticky--fixed
                top 0
        .van-search
            display flex
            align-items center
            padding 0 30px !important
            box-sizing border-box
            height 100%
            .van-search__content
                width auto
                box-sizing border-box
                border-radius 29px
                .van-cell
                    height 60px
                    align-items center
                    .van-field__left-icon
                        display flex
        .van-dialog
            .van-dialog__content
                .wrap
                    padding 50px 0
                    text-align center
                    .red
                        color $fcRed
                .btns
                    display flex
                    .cancel,
                    .confirm
                        height 88px
                        line-height 88px
                        text-align center
                        flex 1
                    .confirm
                        a
                            display block
                            width 100%
                            height 100%
                            color $fcRed
</style>
